import ErrorBoundary from './lib/ErrorBoundary';
// import { router } from './lib/router';
import { theme } from './lib/theme';
import { trpc } from './lib/trpc';
import { Router } from './Router';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { StrictMode, useMemo } from 'react';
import superjson from 'superjson';

// const context = {
//   email: 'biz@face.dev',
//   key: 'user-key-123abcde',
//   kind: 'user',
// };

export const App = () => {
  const queryClient = useMemo(() => new QueryClient(), []);

  const trpcClient = useMemo(() => {
    return trpc.createClient({
      links: [
        httpBatchLink({
          // // You can pass any HTTP headers you wish here
          // async headers() {
          //   return {
          //     authorization: getAuthCookie(),
          //   };
          // },
          fetch(url, options) {
            return fetch(url, {
              ...options,
              credentials: 'include',
            });
          },
          transformer: superjson,
          url: '/api',
        }),
      ],
    });
  }, []);
  return (
    <StrictMode>
      <ErrorBoundary>
        <trpc.Provider
          client={trpcClient}
          queryClient={queryClient}
        >
          <QueryClientProvider client={queryClient}>
            <MantineProvider theme={theme}>
              <ModalsProvider>
                <Notifications position="bottom-center" />
                <Router />
              </ModalsProvider>
            </MantineProvider>
          </QueryClientProvider>
        </trpc.Provider>
      </ErrorBoundary>
    </StrictMode>
  );
};
